import { useState, useEffect } from 'react';
import { getSearchPinState, setSearchPinState, toggleSearchPinState } from '../utils/searchPinManager';

export const useSearchPin = () => {
    console.log('=== useSearchPin hook initialized ===');
    
    const [isSearchPinned, setIsSearchPinned] = useState(() => {
        const initialState = getSearchPinState();
        return initialState;
    });

    useEffect(() => {
        console.log('=== useSearchPin: useEffect triggered ===');
        // Sync with localStorage on mount
        const currentState = getSearchPinState();
        console.log('=== useSearchPin: syncing state with localStorage =', currentState, '===');
        setIsSearchPinned(currentState);
    }, []);

    const toggleSearchPin = () => {
        console.log('=== useSearchPin: toggleSearchPin called ===');
        const newState = toggleSearchPinState();
        console.log('=== useSearchPin: setting state to', newState, '===');
        setIsSearchPinned(newState);
        return newState;
    };

    const setSearchPin = (pinned) => {
        console.log('=== useSearchPin: setSearchPin called with', pinned, '===');
        setSearchPinState(pinned);
        setIsSearchPinned(pinned);
    };

    console.log('=== useSearchPin: returning isSearchPinned =', isSearchPinned, '===');

    return {
        isSearchPinned,
        toggleSearchPin,
        setSearchPin
    };
}; 